import classes from './LifeInsurance.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Link} from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const LifeInsurance = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = t('lifeInsurance.title')
    const description = t('lifeInsurance.text', {returnObjects: true})

    const blackBlocks = t('lifeInsurance.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('lifeInsurance.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('lifeInsurance.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('lifeInsurance.benefitBlocks', {returnObjects: true})

    const stories = t('lifeInsurance.stories', {returnObjects: true})



    const useCaseText = t('lifeInsurance.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
            left: t('lifeInsurance.Faq.left', {returnObjects: true}),
            right: t('lifeInsurance.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    Life Insurance Software Solutions & Policy Management Systems | Goteco
                </title>
                <meta
                    name="description"
                    content="Modernize underwriting, claims processing, and policy administration with secure life insurance IT solutions. Automate workflows and improve customer retention with Goteco."
                />
                <link rel="canonical" href="https://go-te.co/industries/life-insurance" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={700}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('lifeInsurance.blackBlocksTitle')}</h3>
                        <p>{t('lifeInsurance.blackBlocksText')}</p>
                        <p>{t('lifeInsurance.blackBlocksText2')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('lifeInsurance.challengesBlocksTitle')}</h2>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('lifeInsurance.solutionsBlocksTitle')}</h2>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('lifeInsurance.benefitBlocksTitle')}</h2>
                        <p>{t('lifeInsurance.benefitBlocksText')}</p>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('lifeInsurance.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('lifeInsurance.useCase')}</h2>
                            <div className={classes.text}>
                                <img src={eRoadImg} alt="Life insurance use case"/>
                                <p>{useCaseText}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('lifeInsurance.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('lifeInsurance.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img className={classes.img} src={eRoadImg} alt="Life insurance system"/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard 
                        title={t('lifeInsurance.formCard.title')}
                        message={t('lifeInsurance.formCard.message')}
                        buttonText={t('lifeInsurance.formCard.buttonText')}
                        labels={t('lifeInsurance.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
                </section>

                <section className="section--light-gray" id="nav-dark">
                    <FrequentlyAskedQuestions title={t('lifeInsurance.Faq.title')} questions={questions}/>
                </section>
            </main>
        </>

    );
};

export default LifeInsurance;